export enum AppRoute {
  Index = '/csm',
  Resolved = '/csm/resolved',
  Closed = '/csm/closed',
  Search = '/csm/search',
  New = '/csm/new',
  Open = '/csm/open',
  OpenByMe = '/csm/openbyme',
  Info = '/csm/info/:ticketId',
}
